import React from 'react';
import { useDispatch } from 'react-redux';
import {
  forgetPassword,
  LocalizePropType,
  withTextLocalizer,
} from 'getaway-data-layer';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import ForgotPasswordView from './ForgotPasswordView';
import { ForgotPasswordModal, ForgotPasswordSchema } from '../../../validation';
import {
  GA_TITLES,
  navigateTo,
  reportGAEvent,
  showAlert,
} from '../../../utils';

interface Values {
  email: string;
}

type Props = {
  localize: LocalizePropType;
};

const ForgotPasswordContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onSubmit = ({ email }: Values) => {
    dispatch(forgetPassword(email, null, null, localize, onClose));
    reportGAEvent(GA_TITLES.AUTH.FORGOT_SUBMITTED);
  };

  const forgotPasswordFormik = useFormik({
    initialValues: ForgotPasswordModal,
    validationSchema: ForgotPasswordSchema(localize),
    onSubmit,
  });

  const onClose = () => {
    navigateTo(history, '/login');
  };

  const onPressForgotEmail = () => {
    showAlert(
      '',
      localize('forgot.email.dialog.title'),
      localize('forgot.email.dialog.yes'),
      () => navigateTo(history, '/forget-email'),
      localize('cancel')
    );
  };

  return (
    <ForgotPasswordView
      localize={localize}
      formik={forgotPasswordFormik}
      onClose={onClose}
      onPressForgotEmail={onPressForgotEmail}
    />
  );
};

export default withTextLocalizer(ForgotPasswordContainer);
